import { InvoiceData } from "../../types/type";
import { formatCurrency } from "@/utils/utilityFunctions";

export default function Summary({ invoiceData, formType }: { invoiceData: InvoiceData, formType: string }) {
    const calculateSubtotal = (items: Array<{ quantity: number; unitPrice: number }>) => {
        return items.reduce((sum, item) => sum + (item.quantity * item.unitPrice), 0);
    };

    const activeStatuses = ["created", "sent"];

    const calculateTotalAmount = () => {
        let totalAmount = invoiceData.totalAmount;
        const surchargeAmount = (formType === 'card-form' && activeStatuses.includes(invoiceData.status)) ? (invoiceData.cardPaymentOptions?.surchargeAmount || 0) : 0;
        totalAmount += surchargeAmount;
        return totalAmount;
    };

    function renderAdditions(additions: any) {
        if (additions && additions.length > 0) {
            let result = []
            for (let i = 0; i < additions.length; i++) {
                const addition = additions[i];
                if (addition.name !== "" && addition.amount !== "") {
                    result.push(
                        <div key={i} className="flex justify-between items-center font-medium">
                            <span className="whitespace-normal">{addition.name}:</span>
                            <span className="whitespace-nowrap text-blue-600">
                                ${addition.amount/100}
                            </span>
                        </div>
                    )
                }
            }
            return result
        }
        return null
    }

    function renderDeductions(deductions: any) {
        if (deductions && deductions.length > 0) {
            let result = []
            for (let i = 0; i < deductions.length; i++) {
                const deduction = deductions[i];
                if (deduction.name !== "" && deduction.amount !== "") {
                    result.push(
                        <div key={i} className="flex justify-between items-center font-medium">
                            <span className="whitespace-normal">{deduction.name}:</span>
                            <span className="whitespace-nowrap text-blue-600">
                                -${deduction.amount/100}
                            </span>
                        </div>
                    )
                }
            }
            return result
        }
        return null
    }
    const showSurchargeAmount = (typeof invoiceData?.cardPaymentOptions?.surchargeAmount === 'number' &&
        invoiceData.cardPaymentOptions?.surchargeAmount > 0)
    const showTaxAmount = (typeof invoiceData?.taxAmount === 'number' && invoiceData?.taxAmount > 0)
    return (
        <div className="bg-white p-4 rounded-lg shadow-sm">
            <h2 className="text-md font-medium text-gray-800 mb-3">Invoice Summary</h2>
            <div className="grid grid-cols-2 gap-y-2 text-sm">
                <span className="text-gray-600">Invoice ID:</span>
                <span className="text-right font-medium">{invoiceData.id}</span>
                <div className="col-span-2 border-t mt-2 pt-2">
                    <div className="flex justify-between font-medium">
                        <span>Subtotal</span>
                        <span className="text-blue-600">{formatCurrency(calculateSubtotal(invoiceData.items))}</span>
                    </div>
                    {renderAdditions(invoiceData.additions)}
                    {renderDeductions(invoiceData.deductions)}
                    {showSurchargeAmount &&
                        <div className="flex justify-between font-medium">
                            <span>Card Surcharge Amount (When using card payment)</span>
                            <span className="text-blue-600">{formatCurrency(invoiceData.cardPaymentOptions?.surchargeAmount || 0)}</span>
                        </div>
                    }
                    {showTaxAmount &&
                        <div className="flex justify-between font-medium">
                            <span>Tax Amount {invoiceData.taxRate && `(${invoiceData.taxRate! / 100}%)`}</span>
                            <span className="text-blue-600">{formatCurrency(invoiceData.taxAmount || 0)}</span>
                        </div>
                    }
                    <div className="flex justify-between font-medium">
                        <span>Total Amount</span>
                        <span className="text-blue-600">{formatCurrency(calculateTotalAmount())}</span>
                    </div>
                </div>
            </div>
        </div >
    )
}